























































































































































import Vue from 'vue';
import Customer from './Customer';
import { CustomerRequiredFields } from './CustomerRequiredFields';
import { CustomerFieldVisibility, FieldVisibility } from './CustomerFieldVisibility';
import { Dictionary } from 'vue-router/types/router';

const defaultRequiredFields: CustomerRequiredFields = {
    firstName: true,
    lastName: true,
    address1: true,
    address2: false,
    city: true,
    state: true,
    zip: true,
    phoneNumber: false,
    emailAddress: false,
};

const defaultFieldVisibility: CustomerFieldVisibility = {
    recID: FieldVisibility.Hidden,
    firstName: FieldVisibility.Enabled,
    lastName:  FieldVisibility.Enabled,
    address1:  FieldVisibility.Enabled,
    address2:  FieldVisibility.Enabled,
    city:  FieldVisibility.Enabled,
    state:  FieldVisibility.Enabled,
    zip:  FieldVisibility.Enabled,
    phoneNumber:  FieldVisibility.Enabled,
    emailAddress:  FieldVisibility.Enabled
};

export default Vue.extend({
    props: {
        css: {
            type: String,
            required: false
        },
        customer: {
            type: Object as () => Customer,
            required: true
        },
        location: {
            type: String,
            required: true,
        },
        requiredFields: {
            type: Object as () => Partial<CustomerRequiredFields>,
            required: false
        },
        fieldVisibility: {
            type: Object as () => Partial<CustomerFieldVisibility>,
            required: false
        },
        i18nPrefix: {
            type: String,
            required: false,
            default: 'common.customerEdit',
        },
        validationErrors: {
            type: Object as () => Dictionary<string[]>,
            required: false,
            default: (): {} => ({}),
        },
        idPrefix: {
            type: String,
            required: false
        }
    },
    mounted() {
        this.dataCleanup();
    },
    computed: {
        recIDControlID(): string {
            if (!this.idPrefix) {
                return 'rec-id';
            }
            return `${this.idPrefix}-rec-id`;
        },
        firstNameControlId(): string {
            if (!this.idPrefix) {
                return 'first-name';
            }
            return `${this.idPrefix}-first-name`;
        },
        lastNameControlId(): string {
            if (!this.idPrefix) {
                return 'last-name';
            }
            return `${this.idPrefix}-last-name`;
        },
        address1ControlId(): string {
            if (!this.idPrefix) {
                return 'address-1';
            }
            return `${this.idPrefix}-address-1`;
        },
        address2ControlId(): string {
            if (!this.idPrefix) {
                return 'address-2';
            }
            return `${this.idPrefix}-address-2`;
        },
        cityControlId(): string {
            if (!this.idPrefix) {
                return 'city';
            }
            return `${this.idPrefix}-city`;
        },
        stateControlId(): string {
            if (!this.idPrefix) {
                return 'state';
            }
            return `${this.idPrefix}-state`;
        },
        zipControlId(): string {
            if (!this.idPrefix) {
                return 'zip';
            }
            return `${this.idPrefix}-zip`;
        },
        phoneNumberControlId(): string {
            if (!this.idPrefix) {
                return 'phone-number';
            }
            return `${this.idPrefix}-phone-number`;
        },
        emailAddressControlId(): string {
            if (!this.idPrefix) {
                return 'email-address';
            }
            return `${this.idPrefix}-email-address`;
        },
    },
    methods: {
        dataCleanup() {
            Vue.set(this.customer, 'zip', (this.customer && this.customer.zip) ? this.customer.zip.trim() : '');
        },
        checkValid() {
            const requiredFields: string[] = Object.getOwnPropertyNames(this.required);
            let valid = true;

            for (const fieldName of requiredFields) {
                if (this.required &&
                    (this.required as any)[fieldName] &&
                    !(this.customer as any)[fieldName]) {
                    valid = false;
                    break;
                }
            }

            this.isValid = valid;
        },
        fieldVisible(visibility: FieldVisibility): boolean {
            return visibility !== FieldVisibility.Hidden;
        },
        fieldDisabled(visibility: FieldVisibility): boolean {
            return visibility === FieldVisibility.Disabled;
        }
    },
    data() {
        return {
            required: Object.assign({}, defaultRequiredFields, this.requiredFields || {}),
            visibility:  Object.assign({}, defaultFieldVisibility, this.fieldVisibility || {}),
            isValid: false
        };
    },
    watch: {
        customer: {
            deep: true,
            handler() {
                this.checkValid();
                this.dataCleanup();

                this.$emit('input', this.customer);
            }
        },
        isValid() {
            this.$emit('validChanged', this.isValid);
        },
        fieldVisibility: {
            deep: true,
            handler() {
                this.visibility = Object.assign({}, defaultFieldVisibility, this.fieldVisibility || {});
            }
        }
    }
});
